import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { FormValues, UseInitialFormValuesParams } from './EditCounterpartyPaymentDetailsPopupContent.types';

export const useInitialFormValues = (_options: UseInitialFormValuesParams): Partial<FormValues> => {
    // TODO: implement getting data from existing payment details and contact
    return {
        isDefault: false,
        payeeBankCountry: undefined,
        payerBankCountry: undefined,
        currencyCode: undefined,
    };
};

export const useFormSteps = (form: UseFormReturn<FormValues>) => {
    const [currencyCode, payerBankCountry, payeeBankCountry, paymentMethod, legalEntityType] = form.watch([
        'currencyCode',
        'payerBankCountry',
        'payeeBankCountry',
        'paymentMethod',
        'legalEntity.legalEntityType',
    ]);

    // Reset values from step 2 and 3 when base fields(currencyCode, payerBankCountry, payeeBankCountry) are changed
    useEffect(() => {
        const currentValues = form.getValues();

        form.reset({ isDefault: currentValues.isDefault, currencyCode, payerBankCountry, payeeBankCountry });
    }, [form, currencyCode, payerBankCountry, payeeBankCountry]);

    // Reset values from step 3 when values from step 2(paymentMethod, legalEntityType) are changed
    useEffect(() => {
        const currentValues = form.getValues();

        form.reset({
            isDefault: currentValues.isDefault,
            currencyCode: currentValues.currencyCode,
            payerBankCountry: currentValues.payerBankCountry,
            payeeBankCountry: currentValues.payeeBankCountry,
            paymentMethod,
            legalEntity: {
                legalEntityType,
            },
        });
    }, [form, paymentMethod, legalEntityType]);

    return {
        isSecondStepVisible: currencyCode && payerBankCountry && payeeBankCountry,
        isThirdStepVisible: paymentMethod && legalEntityType,
    };
};
